const NEWZOO_PLATFORM_GROUPS: Record<string, string[]> = {
  PC: ['PC'],
  PlayStation: ['PlayStation 4', 'PlayStation 5'],
  Xbox: ['Xbox One', 'Xbox Series X|S'],
  Nintendo: ['Nintendo Switch'],
};

const METRICS_TABLE_PLATFORM_GROUPS: Record<string, Record<string, string[]>> = {
  gsd: {
    PC: ['PC'],
    PlayStation: ['PlayStation 4', 'PlayStation 5'],
    Xbox: ['Xbox One', 'Xbox Series X|S'],
    Nintendo: ['Nintendo Switch'],
  },
  npd: {
    PC: ['PC'],
    PlayStation: ['PlayStation 4', 'PlayStation 5'],
    Xbox: ['Xbox One', 'Xbox Series X|S'],
    Nintendo: ['Nintendo Switch', 'WII U'],
  },
  // enumKey 是 noUpdate，initFormatter 后 value 是 newzoo
  noUpdate: NEWZOO_PLATFORM_GROUPS,
  newzoo: NEWZOO_PLATFORM_GROUPS,
};

export const getMetricsTablePlatformGroupConfig = (source: {
  value?: string;
  key?: string;
}): Record<string, string[]> | undefined =>
  METRICS_TABLE_PLATFORM_GROUPS[source.value || ''] ||
  METRICS_TABLE_PLATFORM_GROUPS[source.key || ''];
